import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import TouchBasedDesktopCartSidebar from "../../../PublicOrdering/TourchBased/TouchBasedDesktopCartSidebar";
import TouchBasedMenuGrid from "../../../PublicOrdering/TourchBased/TouchBasedMenuGrid";
import "swiper/css";

/**
 * TouchBasedLayout Component
 * Handles the touch-based UI layout with cart sidebar and menu grid
 */
const TouchBasedLayout = ({
  loading,
  filteredItems,
  cart,
  imageAds,
  isTouchBasedSetting,
  onAddItem,
  onRemoveItem,
  onCardClick,
  orgData,
  multipleTenant,
}) => {
  // If setting is disabled, show full-width menu with cart
  if (isTouchBasedSetting === false) {
    return (
      <Row style={{ maxHeight: "50vh" }}>
        {/* Desktop Cart Sidebar */}
        <Col lg={12} className="d-none d-lg-block d-md-block">
          <div
            style={{
              position: "sticky",
              height: "calc(100vh - 65vh)",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              border: "none",
              overflow: "hidden",
            }}
          >
            {loading ? (
              <Card
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardBody
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <Skeleton height={20} width="60%" borderRadius={4} />
                  <Skeleton height={40} borderRadius={6} />
                  <Skeleton height={60} borderRadius={8} />
                  <Skeleton height={60} borderRadius={8} />
                  <Skeleton height={60} borderRadius={8} />
                  <div style={{ flex: 1 }} />
                  <Skeleton height={40} borderRadius={6} />
                </CardBody>
              </Card>
            ) : (
              <TouchBasedDesktopCartSidebar
                cart={cart}
                orgInfo={orgData}
                orgData={orgData}
                multipleTenant={multipleTenant}
              />
            )}
          </div>
        </Col>

        {/* Menu Grid */}
        <Col xs={12} lg={12}>
          {loading ? (
            <Row>
              {[...Array(16)].map((_, idx) => (
                <Col xs={6} sm={6} md={3} lg={3} key={idx}>
                  <Card
                    className="border-0"
                    style={{ borderRadius: 10, padding: 6 }}
                  >
                    <Skeleton height={90} borderRadius={6} />
                    <CardBody style={{ padding: 8 }}>
                      <Skeleton
                        height={14}
                        width="80%"
                        style={{ marginBottom: 6 }}
                      />
                      <Skeleton height={14} width="60%" />
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <TouchBasedMenuGrid
              filteredItems={filteredItems}
              cart={cart.map((c) => ({
                id: c.productId || c.id,
                quantity: c.quantity || c.qty,
              }))}
              onAdd={onAddItem}
              onRemove={onRemoveItem}
              onCardClick={onCardClick}
              multipleTenant={multipleTenant}
            />
          )}
        </Col>

        {/* Image Ads Carousel */}
        {imageAds.length > 0 && (
          <Col md={12}>
            <Swiper
              modules={[Autoplay]}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              loop={true}
              speed={800}
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                marginTop: "10px",
              }}
            >
              {imageAds.map((ad) => (
                <SwiperSlide key={ad.id}>
                  <img
                    src={ad.mediaPath}
                    alt={ad.title || "Ad"}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        )}
      </Row>
    );
  }

  // Normal touch-based layout
  return (
    <Row style={{ maxHeight: "100dvh" }} className="">
      <Col xs={12} lg={8}>
        {loading ? (
          <Row>
            {[...Array(16)].map((_, idx) => (
              <Col xs={6} sm={6} md={3} lg={3} key={idx}>
                <Card
                  className="border-0"
                  style={{ borderRadius: 10, padding: 6 }}
                >
                  <Skeleton height={90} borderRadius={6} />
                  <CardBody style={{ padding: 8 }}>
                    <Skeleton
                      height={14}
                      width="80%"
                      style={{ marginBottom: 6 }}
                    />
                    <Skeleton height={14} width="60%" />
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <TouchBasedMenuGrid
            filteredItems={filteredItems}
            cart={cart.map((c) => ({
              id: c.productId || c.id,
              quantity: c.quantity || c.qty,
            }))}
            onAdd={onAddItem}
            onRemove={onRemoveItem}
            onCardClick={onCardClick}
            multipleTenant={multipleTenant}
          />
        )}
      </Col>

      <Col lg={4} className="d-none d-lg-block d-md-block">
        <div
          style={{
            position: "sticky",
            height: "calc(100vh - 40vh)",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            border: "none",
            overflow: "hidden",
          }}
        >
          {loading ? (
            <Card
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardBody
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <Skeleton height={20} width="60%" borderRadius={4} />
                <Skeleton height={40} borderRadius={6} />
                <Skeleton height={60} borderRadius={8} />
                <Skeleton height={60} borderRadius={8} />
                <Skeleton height={60} borderRadius={8} />
                <div style={{ flex: 1 }} />
                <Skeleton height={40} borderRadius={6} />
              </CardBody>
            </Card>
          ) : (
            <TouchBasedDesktopCartSidebar
              cart={cart}
              orgInfo={orgData}
              orgData={orgData}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default TouchBasedLayout;
